import React, { useState, useEffect } from "react";
import { sendGetRequest, sendGetRequestApi } from "../../services/service";
import { config } from "../../config/dev";
import {
  Row,
  Col,
  CardBody,
  Input,
  Badge,
  Button,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";
import "react-super-responsive-table/dist/SuperResponsiveTableStyle.css";
import { dateyyyymmdd_tohtml } from "../../helpers/date";
// import { useSelector } from "react-redux/es/hooks/useSelector";
import Select from "react-select";
import FeatherIcon from "feather-icons-react";

//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb";
// import Pagination from "../../components/Common/Pagination"
import { Link } from "react-router-dom";
// import QuestionMasterOffCanvas from "../../components/questionMaster/QuestionMasterOffCanvas";
import QuestionMasterOffCanvas from "../../components/questionMaster/QuestionMasterOffCanvas";
import CustomTable from "../../common/CustomTable";
import moment from "moment";
import { current } from "@reduxjs/toolkit";
import TableLoader from "../../components/Common/TableLoader";
import { log_debug } from "../../helpers/logger";
import McqOffCanvas from "../../components/questionMaster/McqOffCanvas";
import { getMcq } from "../../store/api/getApi/getApiSlice";
import { useDispatch, useSelector } from "react-redux";
import { toast, ToastContainer } from "react-toastify";

function QuestionMaster() {
  // const addTodo=useSelector(state=>state.todos)

  // const [copyData, setCopyData] = useState([])
  // const [copied, setCopied] = useState(false)
  const dispatch = useDispatch();
  const getApiStore = useSelector((state) => state.getApi);
  const [questionmaster, setQuestion_master] = useState(null);
  const [isPreloader, setIsPreloader] = useState(false);
  // const [state, setState] = useState("");
  const [selectedMcq, setSelectedMcq] = useState("");
  const [isRight, setIsRight] = useState(false);
  const [searchedWord, setSearchedWord] = useState("");
  const [currentPage, setCurrentPage] = useState(0);
  const [totalCount, setTotalCount] = useState(0);
  const [difficulty, setDifficulty] = useState("");
  const [status, setStatus] = useState("");

  let SearchedValue = "";

  // const [isLoading, setIsLoading] = useState(true);

  // const [tableData, setTableData] = useState([])
  const columns = [
    {
      Header: "Question ",
      accessor: "question",
      Cell: ({ row }) => (
        <Link
          to="#"
          style={{ cursor: "pointer", textDecoration: "underline" }}
          onClick={() => toggleRightCanvas(row.original)}
        >
          {row.original.question}
        </Link>
        // <ReadMoreComponent
        //   // key={index}
        //   text={row.original.question}
        //   maxWords={maxWords}
        //   toggleFunc={toggleRightCanvas}
        //   rowData={row}
        // />
      ),
    },
    {
      Header: "Category",
      accessor: "category",
    },
    {
      Header: "Skills",
      accessor: "skillTags",
      Cell: ({ row }) =>
        row.original.skillTags.length > 0 && (
          // <ul style={{ padding: '1rem' }}>
          <>
            {" "}
            {row.original.skillTags.map((skill, index) => (
              <span key={index} className="bg-success badge me-1 bg-primary">
                {skill}
              </span>
            ))}
          </>
        ),
    },
    {
      Header: "Difficulty",
      accessor: "difficultyLevel",
      Cell: ({ row }) => (
        <>
          <span
            className={`badge me-1 ${row.original.difficultyLevel === "easy" ? "bg-success" : row.original.difficultyLevel === "medium" ? "bg-warning" : "bg-danger"}`}
          >
            {row.original.difficultyLevel}
          </span>
        </>
      ),
    },
    {
      Header: "Status",
      accessor: "status",
      Cell: ({ row }) => (
        <>
          <div>
            <span
              className={`badge ${row.original.status === "draft" ? "bg-warning" : row.original.status === "active" ? "bg-success" : "bg-danger"}`}
            >
              {row.original.status}
            </span>
          </div>
        </>
      ),
    },
    {
      Header: "Actions",
      accessor: "edit",
      Cell: ({ row }) => (
        <>
          <div className="text-center">
            <Button
              color="primary"
              onClick={() => toggleRightCanvas(row.original)}
            >
              <i className="mdi mdi-eye" />
            </Button>
          </div>
        </>
      ),
    },

    // {
    //   Header: "Status",
    //   accessor: "status",
    // },
    // {
    //   Header: "Type",
    //   accessor: "type",
    //   Cell: ({ row }) =>
    //   <div className="hstack">
    //     <Badge className="rounded-pill bg-primary-subtle text-muted">{row.original.type}</Badge>
    //     <div>
    //    { row.original.skills.length !== 0
    //       ? row.original.skills.map((skill,index) => (
    //           <Badge key={index} className="rounded-pill ms-2 bg-info-subtle text-muted">{skill}</Badge>
    //         ))
    //       : ""}
    //     </div>
    //   </div> ,
    // },

    // {
    //   Header: "Created Date",
    //   accessor: "createdAt",
    //   Cell: ({ row }) => moment(row.original.createdAt).format("DD MMM, YYYY"),
    // },
  ];
  const handlePageChange = (newPage) => {
    setCurrentPage(newPage);
    if(newPage === 0){
      dispatch(
        getMcq({
          currentPage: newPage,
          difficulty: difficulty,
          questionstatus: status,
          searchedWord: searchedWord,
        })
      );
    }
  };

  useEffect(() => {
    if(currentPage || difficulty || status || searchedWord || searchedWord === ""){
    const timer = setTimeout(() => {
      dispatch(
        getMcq({
          currentPage: currentPage,
          difficulty: difficulty,
          questionstatus: status,
          searchedWord: searchedWord,
        })
      );
    }, 700);

  return () => clearTimeout(timer);
    }
  }, [currentPage, difficulty, status, searchedWord]);

  useEffect(() => {
    // If API is idle and there is data, update state
    if (getApiStore.status === "idle") {
      if (getApiStore?.data?.mcqData?.success === true) {
        setQuestion_master(getApiStore?.data?.mcqData?.data);
        setTotalCount(getApiStore?.data?.mcqData?.pagination?.totalMcqs);
      } else {
        // Check if user is still authenticated before dispatching API request
        const sessionToken = localStorage.getItem("sessionToken");
  
        if (sessionToken) {
          dispatch(
            getMcq({
              currentPage: currentPage,
              difficulty: difficulty,
              questionstatus: status,
              searchedWord: searchedWord,
            })
          );
        } else {
          console.warn("User is not authenticated. Stopping API calls.");
        }
      }
    }
  }, [getApiStore?.data?.mcqData, currentPage, difficulty, status, searchedWord, dispatch]);
  

  function handleSearchedVal(event) {
    SearchedValue = event.target.value;
  }

  function toggleRightCanvas(data) {
    setSelectedMcq(data);
    setIsRight(!isRight);
  }

  const handleClick = (event) => {
    // setSearchedWord(SearchedValue);
    // 👇️ value of input field
  };
  const handleSearchOnEnter = (event) => {
    if (event.key === "Enter") {
      // Perform your search logic here
      handleClick();
    }
  };

  // useEffect(() => {
  //   setIsPreloader(true);
  //   sendGetRequest(
  //     null,
  //     `https://i8e43d5anj.execute-api.ap-south-1.amazonaws.com/latest/v1/questioncorpus?search_query=${searchedWord}&limit=10`,
  //     (_question_corpus_err, _question_corpus_res) => {
  //       ////document.getElementById("preloader").style.display = "block";
  //       if (_question_corpus_res) {
  //         setQuestion_master(_question_corpus_res.questioncorpuses);
  //         setIsPreloader(false);
  //       }
  //     },
  //   );
  // }, [searchedWord]);

  const handleFilter = (value) => {
    log_debug("handlefilter", "mcqtable", JSON.stringify(value));
    if (value?.name === "difficulty") {
      setDifficulty(value?.value);
    } else if (value?.name === "status") {
      setStatus(value?.value);
    } else if (value?.name === "globalFilter") {
      console.log("inside")
      setSearchedWord(value?.value);
    }
  };


  const handleToast = (status) => {
    if(status?.status === "Record deleted successfully"){
      toast.success(status?.status);
      setIsRight(false);
    }
  }

  useEffect(() => {
    return () => {
      document.body.style.overflow = "auto";
      document.body.style.paddingRight = "0px"; // Reset padding
    };
  }, [isRight]);

  //meta title
  // document.title = "Responsive Table | Minia - React Admin & Dashboard Template";

  return (
    <React.Fragment>
      <div className="page-content">
        <div className="container-fluid">
          <Breadcrumbs title="Question Corpus" />
          <Row>
            <Col>
              {/* <Card> */}

              <CardBody>
                <div className="table-rep-plugin">
                  <div className=" mb-0" data-pattern="priority-columns">
                    {questionmaster ? <CustomTable
                      currentPage={currentPage}
                      onPageChange={handlePageChange}
                      data={questionmaster}
                      columns={columns}
                      totalCount={totalCount}
                      showFilters={true}
                      onFilterChange={handleFilter}
                      isloading={!isPreloader}
                    /> : <TableLoader/>}
                  </div>
                </div>
              </CardBody>
              {/* </Card> */}
            </Col>
          </Row>
          {isRight && (
            // <QuestionMasterOffCanvas
            //   is_Right={isRight}
            //   toggleRightCanvas={toggleRightCanvas}
            //   qm_guid={gu_id}
            // />
            <McqOffCanvas
              type={"mcq"}
              isOpen={isRight}
              toggleRightCanvas={toggleRightCanvas}
              mcqData={selectedMcq}
              handleToast = {handleToast}
            />
          )}
        </div>
      </div>
      <ToastContainer/>
    </React.Fragment>
  );
}

export default QuestionMaster;
